import React, { useState } from 'react';
import './Login.css';

const Login = () => {
  // 登录类型：password = 密码登录  code = 验证码登录
  const [loginType, setLoginType] = useState('password');
  const [form, setForm] = useState({
    phone: '',
    password: '',
    code: ''
  });
  const [btnText, setBtnText] = useState('获取验证码');
  const [disabled, setDisabled] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 获取短信验证码（登录用）
  const getCode = async () => {
    if (!form.phone) { alert('请输入手机号'); return; }
    try {
      const res = await fetch('http://111.229.118.87:5000/api/send-login-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: form.phone })
      });
      const data = await res.json();
      if (data.code === 200) {
        alert('验证码已发送');
        let sec = 60;
        setDisabled(true);
        const timer = setInterval(() => {
          sec--;
          setBtnText(sec + '秒后重发');
          if (sec <= 0) {
            clearInterval(timer);
            setBtnText('获取验证码');
            setDisabled(false);
          }
        }, 1000);
      } else alert(data.msg);
    } catch (e) { alert('发送失败'); }
  };

  // 登录提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = loginType === 'password'
        ? 'http://111.229.118.87:5000/api/login-pwd'
        : 'http://111.229.118.87:5000/api/login-code';

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.code === 200) {
        alert('登录成功');
        localStorage.setItem('token', 'ok');
        window.location.href = '/student';
      } else {
        alert(data.msg);
      }
    } catch (err) {
      alert('服务器异常');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>励鲲英语 - 登录</h2>
        <div className="tab-row">
          <button className={loginType==='password'?'active':''} onClick={()=>setLoginType('password')}>密码登录</button>
          <button className={loginType==='code'?'active':''} onClick={()=>setLoginType('code')}>验证码登录</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-item">
            <label>手机号</label>
            <input name="phone" value={form.phone} onChange={handleChange} required />
          </div>

          {loginType === 'password' ? (
            <div className="input-item">
              <label>密码</label>
              <input type="password" name="password" value={form.password} onChange={handleChange} required />
            </div>
          ) : (
            <div className="input-item code-row">
              <label>短信验证码</label>
              <div style={{ display: 'flex', gap: 10 }}>
                <input name="code" value={form.code} onChange={handleChange} required />
                <button type="button" className="code-btn" onClick={getCode} disabled={disabled}>{btnText}</button>
              </div>
            </div>
          )}

          <button type="submit" className="login-btn">立即登录</button>
        </form>
        <p className="to-register">没有账号？<a href="/register">立即注册</a></p>
      </div>
    </div>
  );
};

export default Login;